interface CommonStyles {
  [key: string]: { [key: string]: string | number };
}

export const commonStyles: CommonStyles = {
  // Remember that flex parent should have minWidth: '0px' to make this work
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
